import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (!this.bound) {
      this.closeFromClick = this.closeFromClick.bind(this);
      this.closeFromKeyboard = this.closeFromKeyboard.bind(this);
      this.element.addEventListener("click", this.closeFromClick);
      this.bound = true;
    }

    if (this.hasModalContent()) {
      this.open();
    }
  }

  disconnect() {
    this.element.removeEventListener("click", this.closeFromClick);
    document.removeEventListener("keydown", this.closeFromKeyboard);
    this.unlockScroll();
  }

  open(event) {
    if (event) event.preventDefault();

    const dialog = this.dialogElement();
    if (dialog && !dialog.open) {
      dialog.showModal();
    }

    document.addEventListener("keydown", this.closeFromKeyboard);
    this.lockScroll();
  }

  close(event) {
    if (event) event.preventDefault();

    const dialog = this.dialogElement();
    if (dialog && dialog.open) {
      dialog.close();
    }

    const frame = this.frameElement();
    if (frame) {
      this.clearFrame(frame);
    } else {
      this.element.remove();
    }

    document.removeEventListener("keydown", this.closeFromKeyboard);
    this.unlockScroll();
  }

  closeFromClick(event) {
    if (event.target.closest("[data-modal-close]")) {
      this.close(event);
    }
  }

  closeFromKeyboard(event) {
    if (event.key === "Escape") {
      this.close(event);
    }
  }

  hasModalContent() {
    return this.element.matches("[role='dialog'], dialog") ||
      this.element.querySelector("[role='dialog'], dialog");
  }

  dialogElement() {
    if (this.element instanceof HTMLDialogElement) {
      return this.element;
    }

    return this.element.querySelector("dialog");
  }

  frameElement() {
    return this.element.closest("turbo-frame") || (
      this.element.tagName === "TURBO-FRAME" ? this.element : null
    );
  }

  clearFrame(frame) {
    if (frame) {
      frame.removeAttribute("src");
      frame.innerHTML = "";
    }
  }

  lockScroll() {
    document.body.classList.add("modal-scroll-locked");
  }

  unlockScroll() {
    document.body.classList.remove("modal-scroll-locked");
  }
}
